import { useUser } from "../components/UserContext/UserContextProvider"

export const useIsSupervisor = () => {
  const { user } = useUser()

  return user?.subRole?.value === 'supervisor'
}